<script setup lang="ts">
import { CalendarEvent } from "@/ts/stores/event";
import { dateString } from "@/ts/utils/event-utils";

interface Props {
    event: CalendarEvent;
    appName?: string;
}

const props = defineProps<Props>();

const baseUrl = props.appName === "PLUG-IN" ? "https://hajee.be/event" : "/event";
</script>

<template>
    <a :href="`${baseUrl}/${event.post_name}`" :target="appName === 'PLUG-IN' ? '_blank' : undefined" class="group flex w-full flex-col">
        <div class="relative mb-10 w-full overflow-hidden  lg:mb-6">
            <div class="relative pt-[62.925170068%]">
                <img :src="event.acf.media.thumbnail.url" class="absolute inset-0 h-full w-full object-cover object-center transition-transform duration-300 group-hover:scale-110" :alt="event.post_title" />
                <span v-if="event.acf.info.event_label" class="btn btn-black btn-sm absolute top-4 right-4 group-hover:bg-black group-hover:text-white" v-html="event.acf.info.event_label"></span>
            </div>
        </div>
        <div class="flex flex-col justify-between gap-4">
            <p class="font-heading text-40 font-[690] uppercase line-clamp-1 [font-stretch:_190%] md:text-48" v-html="event.post_title"></p>
            <div class="flex flex-wrap items-start gap-4 lg:items-center">
                <span class="btn border-blue bg-blue text-black" v-html="dateString(event)"></span>
                <span class="btn btn-pink" v-if="(event.acf.info.event_type === 'only_registrations' || event.acf.info.event_type === 'registration_and_payment') && event.acf.info.registrations_open">
                    Schrijf je nu in
                    <svg-vue icon="arrow" class="ml-[.625rem] h-6 w-auto"></svg-vue>
                </span>
                <span class="btn btn-pink" v-else-if="event.acf.info.event_type === 'external_ticketing'">
                    Koop tickets
                    <svg-vue icon="arrow" class="ml-[.625rem] h-6 w-auto"></svg-vue>
                </span>
                <span class="btn btn-pink" v-else>
                    Lees meer
                    <svg-vue icon="arrow" class="ml-[.625rem] h-6 w-auto"></svg-vue>
                </span>
            </div>
        </div>
    </a>
</template>
